import Habilitations from './Constructor'

export default Habilitations
export { Habilitations }
